import React from 'react';
import {
  Card,
  Col,
  Row,
  Table,
} from 'antd';
import Loading from '../../../components/Loading';
import DescriptionItem from './DescriptionItem';
import { Business } from '../../../models/Business';
import { formatDate } from '../../../util';

const { Column }=Table;

export type Props = {
  business: Business|undefined;
};

const SubscriptionDetails: React.FC<Props>= ({ business }) => {
  if (!business?.subscription) {
    return (
      <Loading tip='Loading subscription.'/>
    )
  }

  const {
    plan: {
      name
    },
    created,
    current_period_start,
    current_period_end,
    cancel_at_period_end,
    canceled_at,
  } = business.subscription;

  return (
    <Card bodyStyle={{ padding: 0 }}>
      <div className="p-4">
        <Row gutter={[16,16]}>
          <Col xs={24} sm={12}>
            <DescriptionItem
              title="Billing cycle start:"
              content={current_period_start ? formatDate(current_period_start * 1000) : 'N/A'}
            />
          </Col>
          <Col xs={24} sm={12}>
            <DescriptionItem
              title="Billing cycle end:"
              content={current_period_end ? formatDate(current_period_end * 1000) : 'N/A'}
            />
          </Col>
          <Col xs={24} sm={12}>
            <DescriptionItem
              title="Created:"
              content={formatDate(created * 1000)}
            />
          </Col>
          <Col xs={24} sm={12}>
            <DescriptionItem
              title="Plan:"
              content={name}
            />
          </Col>
          <Col xs={24} sm={12}>
            <DescriptionItem
              title="Is cancelling:"
              content={cancel_at_period_end ? "Yes" : "No"}
            />
          </Col>
          <Col xs={24} sm={12}>
            <DescriptionItem
              title="Cancelled at:"
              content={canceled_at ? formatDate(canceled_at * 1000) : 'N/A'}
            />
          </Col>
        </Row>
      </div>
    </Card>
  );
}

export default SubscriptionDetails;
